var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"context"},[_c('overview',{attrs:{"showCheck":false}}),_c('CardGrid4'),_c('ChartLine'),_c('Compare',{on:{"transfer":_vm.getUser}}),(_vm.transfer.dateType)?_c('Compare1',{key:_vm.random+'h',attrs:{"date":_vm.transfer}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }